import { render, staticRenderFns } from "./SummaryWrapper.vue?vue&type=template&id=2175961e&scoped=true&"
import script from "./SummaryWrapper.vue?vue&type=script&lang=js&"
export * from "./SummaryWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175961e",
  null
  
)

export default component.exports